import React, { useContext, useEffect, useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import BetList from '../components/BetList';
import HomeTopBanner from '../components/HomeTopBanner';
import config from '../config';
import { Link } from 'react-router';
import { GlobalContext } from '../global/GlobalProvider';
import { useTranslation } from 'react-i18next';
function Home() {
const [featureEvent, setFeatureEvent] = useState();
const { setIsBannerOpen,loggedIn } = useContext(GlobalContext);
const { t, i18n } = useTranslation();
  // useEffect(() => {
  //         document.body.classList.add("home-ver2");
  //         return () => {
  //             document.body.classList.remove("home-ver2");
  //         };
  //       }, []);

const featureMatch = () => {
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        const requestOptions = {
          method: "GET",
          headers: myHeaders,
          redirect: "follow",
        };

        fetch(
          `${process.env.REACT_APP_BASE_URL}/featureEvent`,
          requestOptions
        )
          .then(async (response) => {
              let paresData = await response.json();
              setFeatureEvent(paresData);
          })
          .catch((error) => {
            console.log(error);
          });
      };

      useEffect(() => {
        featureMatch();
      }, []);

      const getImageClass = (sportId) => {
        if (sportId === "1") {
           return 'd-icon icon-1';
        }else if (sportId === "4") {
           return 'd-icon icon-4';
        }else if (sportId === "2") {
           return 'd-icon icon-2';
        }else if (sportId === "400") {
           return 'd-icon icon-66';
        }else if (sportId === "500") {
          return 'd-icon icon-40';
        }else if (sportId === "4339") {
          return 'd-icon icon-65';
        }else if (sportId === "7") {
          return 'd-icon icon-10';
        }else{
           return 'd-icon icon-4';
        }
     }

      const getTabHead = (isActiveSport) => {
        if (isActiveSport === config.SpidCricket) {
          return {
            backgroundColor: config.ColorCricket,
            color: '#fff'
          };
        } else if (isActiveSport === config.SpidFootball) {
            return {
              backgroundColor: config.ColorFootball,
              color: '#fff'
            };
        } else if (isActiveSport === config.SpidTennis) {
            return {
              backgroundColor: config.ColorTenis,
              color: '#fff'
            };
        } else if (isActiveSport === config.SpidElection) {
            return {
              backgroundColor: config.ColorElection,
              color: '#fff'
            };
        } else if (isActiveSport === config.SpidKabaddi) {
            return {
              backgroundColor: config.ColorKabaddi,
              color: '#fff'
            };
        } else if (isActiveSport === config.SpidGreyhoundRacing) {
            return {
              backgroundColor: config.ColorGreyhoundRacing,
              color: '#fff'
            };
        } else if (isActiveSport === config.SpidHorseRacing) {
            return {
              backgroundColor: config.ColorHorseRacing,
              color: '#fff'
            };
        }else{
            return {}
        }
      };

      useEffect(() => {
        let asd = config.bannerOpen;
          if(asd == 'false'){
            setIsBannerOpen(true);
          }else{
            setIsBannerOpen(false);
          }
      }, []);

      const ourCasino = (count) => {
        return (<div className="sidebar-content">
          <Swiper
            loop={true}
            effect={"fade"}
            // direction={'vertical'}
            autoplay={{
              delay: 2000,
              disableOnInteraction: false,
            }}
            modules={[Autoplay]}
            breakpoints={{
              320: {
                direction: "horizontal",
                slidesPerView: sessionStorage.getItem('loggedIn') || loggedIn ? 3 : 2,
                spaceBetween: 5,
              },
              768: {
                direction: "horizontal",
                slidesPerView: count,
                spaceBetween: 5,
              },
              1280: {
                direction: "vertical",
                slidesPerView: count,
                spaceBetween: 5,
              },
            }}
            className="our-casino-slider"
          >
            <SwiperSlide> <img src="images/teen20c.jpg" alt="" /> </SwiperSlide>
            <SwiperSlide> <img src="images/btable2.jpg" alt="" /> </SwiperSlide>
            <SwiperSlide> <img src="images/ourroullete.jpg" alt="" /> </SwiperSlide>
            <SwiperSlide> <img src="images/teen20c.jpg" alt="" /> </SwiperSlide>
            <SwiperSlide> <img src="images/btable2.jpg" alt="" /> </SwiperSlide>
            <SwiperSlide> <img src="images/ourroullete.jpg" alt="" /> </SwiperSlide>
            <SwiperSlide> <img src="images/teen20c.jpg" alt="" /> </SwiperSlide>
            <SwiperSlide> <img src="images/btable2.jpg" alt="" /> </SwiperSlide>
            <SwiperSlide> <img src="images/ourroullete.jpg" alt="" /> </SwiperSlide>
            <SwiperSlide> <img src="images/teen20c.jpg" alt="" /> </SwiperSlide>
            <SwiperSlide> <img src="images/btable2.jpg" alt="" /> </SwiperSlide>
            <SwiperSlide> <img src="images/ourroullete.jpg" alt="" /> </SwiperSlide>
          </Swiper>
        </div>);
      }


      const topWinner = () => {
        return ( <div className="sidebar-box top-result">
          <div className="sidebar-title">{t('WinnerAnnouncement')}</div>
          <div className="sidebar-content">
            <Swiper
              loop={true}
              direction={'vertical'}
              slidesPerView= {3}
              autoplay={{
                delay: 2000,
                disableOnInteraction: false,
              }}
              modules={[Autoplay]}
              className="winner-announcement-slider"
            >
              <SwiperSlide>
                <div class="top-result-box">
                    <div className='winner-name'>
                      <b>Ps****</b>
                    </div>
                    <div className='winner-info'>
                      <div className="amount">1,00,15,000</div>
                    <div className='date'>08/04/2025 04:36</div>
                      </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div class="top-result-box">
                    <div className='winner-name'>
                      <b>Ps****</b>
                    </div>
                    <div className='winner-info'>
                      <div className="amount">1,00,15,000</div>
                    <div className='date'>08/04/2025 04:36</div>
                      </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div class="top-result-box">
                    <div className='winner-name'>
                      <b>Ps****</b>
                    </div>
                    <div className='winner-info'>
                      <div className="amount">1,00,15,000</div>
                    <div className='date'>08/04/2025 04:36</div>
                      </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div class="top-result-box">
                    <div className='winner-name'>
                      <b>Ps****</b>
                    </div>
                    <div className='winner-info'>
                      <div className="amount">1,00,15,000</div>
                    <div className='date'>08/04/2025 04:36</div>
                      </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </div>
        </div>);
      }

      const newLunch = () => {
        return (<div className="sidebar-box new-launched-sidebar mobile-hide">
          <div className="sidebar-title"> {t('NewLaunched')} </div>
          <div className="sidebar-content">
            <Swiper
              loop={true}
              effect={"fade"}
              // direction={'vertical'}
              autoplay={{
                delay: 2000,
                disableOnInteraction: false,
              }}
              modules={[Autoplay]}
              breakpoints={{
                320: {
                  direction: "horizontal",
                  slidesPerView: 1,
                  spaceBetween: 5,
                },
                767: {
                  direction: "horizontal",
                  slidesPerView:1,
                  spaceBetween: 5,
                },
                1024: {
                  direction: "horizontal",
                  slidesPerView: 1,
                },
                1279: {
                  direction: "vertical",
                  slidesPerView: 1,
                },
              }}
              className="new-launched-slider"
            >
              <SwiperSlide> <img src="images/teen20c.jpg" alt="" /> </SwiperSlide>
              <SwiperSlide> <img src="images/btable2.jpg" alt="" /> </SwiperSlide>
              <SwiperSlide> <img src="images/ourroullete.jpg" alt="" /> </SwiperSlide>
            </Swiper>
          </div>
      </div>
      );
      }

  return (
    <div className='content-box w-sidebar'>
      <div className="left-content">
      <div className="new-event">
      {featureEvent && featureEvent.featureVenetData.map((gameItem, index) => (
        <div className="new-event-item" key={index} style={getTabHead(gameItem.sportId)}>
          <Link to={`/exchange_inPlay/${gameItem.eventId}`}>
            <i className={`${getImageClass(gameItem.sportId)}`}></i>
            <span className="ml-2">{gameItem.eventName}</span>
          </Link>
        </div>
      ))}
      </div>


      <HomeTopBanner />
        <BetList />
      </div>



      {(sessionStorage.getItem('loggedIn') || loggedIn) ?
       <div className="right-content sidebar">
        <div className="sidebar-box our-casino-sidebar-full">
          <div className="sidebar-title desktop-hide">{t('OurCasino')}</div>
          {ourCasino(4)}
        </div>
        <div className="sidebar-box our-casino-sidebar desktop-hide">
          <div className="sidebar-title desktop-hide">{t('NewGames')}</div>
          {ourCasino(4)}
        </div>
        </div> :
        <div className="right-content sidebar">
           {sessionStorage.getItem('loggedIn') || loggedIn ? '' :topWinner()}
          {newLunch()}
          <div className="sidebar-box our-casino-sidebar">
            <div className="sidebar-title"> {t('OurCasino')} </div>
              {ourCasino(3)}
          </div>
      </div>
      }

      </div>
  )
}

export default Home